import React from 'react'
import Moment from 'react-moment'
import NumberFormat from 'react-number-format'
import { Icon } from 'semantic-ui-react'

import { Field } from 'redux-form'
import FieldInput, { InputType as type } from '../../components/SemanticForm'

const ui = {
  yes: 'check icon green',
  no: 'close icon red',
  bug: <i className="bug icon"></i>,
  active: 'check circle icon green',
  inactive: 'exclamation triangle icon yellow',
}

export const columns = {
  tUser: [
    {
      Header: 'Username',
      accessor: 'username',
      width: 150,
    },
    {
      Header: 'Name',
      accessor: 'fullName',
      width: 200,
    },
    {},
  ],
  tUserRole: [
    {
      Header: '',
      width: 30,
      Cell: row => <Icon name="trash alternate" link color="red" />,
    },
    {
      Header: 'Role Name',
      accessor: 'roleName',
      width: 150,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 150,
    },
    {
      Header: 'CreatedByName',
      accessor: 'createdByName',
      width: 150,
    },
    {
      Header: 'CreatedByUser',
      accessor: 'createdByUser',
      width: 150,
    },
    {
      Header: 'CreatedDate',
      accessor: 'createdDate',
      width: 150,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {},
  ],
  tRole: [
    {
      Header: 'Role Name',
      accessor: 'name',
      width: 150,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 150,
    },
    {
      Header: 'Active',
      accessor: 'active',
      width: 100,
      Cell: row => <i className={row.value ? ui.active : ui.inactive}></i>,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'ModifiedByName',
      accessor: 'modifiedByName',
      width: 150,
    },
    {
      Header: 'ModifiedDate',
      accessor: 'modifiedDate',
      width: 130,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {
      Header: 'CreatedByName',
      accessor: 'createdByName',
      width: 150,
    },
    {
      Header: 'CreatedDate',
      accessor: 'createdDate',
      width: 150,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {},
  ],
  tPermissionRole: [
    {
      Header: 'Permission Name',
      accessor: 'name',
      width: 150,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 250,
    },
    {
      Header: 'View',
      accessor: 'allowView',
      width: 80,
      Cell: row => <i className={row.value ? ui.yes : ui.no}></i>,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Create',
      accessor: 'allowCreate',
      width: 80,
      Cell: row => <i className={row.value ? ui.yes : ui.no}></i>,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Edit',
      accessor: 'allowEdit',
      width: 80,
      Cell: row => <i className={row.value ? ui.yes : ui.no}></i>,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Delete',
      accessor: 'allowDelete',
      width: 80,
      Cell: row => <i className={row.value ? ui.yes : ui.no}></i>,
      style: {
        textAlign: 'center',
      },
    },
  ],
  tPermission: [
    {
      Header: 'Permission Name',
      accessor: 'name',
      width: 150,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 250,
    },
    {
      Header: 'ModifiedByName',
      accessor: 'modifiedByName',
      width: 150,
    },
    {
      Header: 'ModifiedDate',
      accessor: 'modifiedDate',
      width: 150,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {
      Header: 'CreatedByName',
      accessor: 'createdByName',
      width: 150,
    },
    {
      Header: 'CreatedDate',
      accessor: 'createdDate',
      width: 150,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {},
  ],
  tUserDepartment: [
    {
      Header: 'User Name',
      accessor: 'username',
      width: 150,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Modified By',
      accessor: 'modifiedBy',
      width: 150,
    },
    {
      Header: 'Modified Date',
      accessor: 'modifiedDate',
      width: 150,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {},
  ],
  tMainDepartment: [
    {
      Header: 'Code',
      accessor: 'mainDepartmentCode',
      width: 50,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Main Department',
      accessor: 'mainDepartmentName',
    },
  ],
  tSubDepartment: [
    {
      Header: '',
      width: 30,
      Cell: row => <Icon name="trash alternate" link color="red" />,
    },
    {
      Header: 'Code',
      accessor: 'subDepartment',
      width: 50,
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'Sub Department',
      accessor: 'subDepartmentName',
    },
    {},
  ],
  tDepartment: [
    {
      Header: () => {
        return (
          <span>
            Select All
            <Field
              name="Select"
              type={type.checkbox}
              style={{ margin: '0 45%' }}
              component={FieldInput}
            />
          </span>
        )
      },
      sortable: false,
      accessor: 'subDepartmentCode',
      width: 75,
      Cell: row => (
        <Field
          name={`items.${row.value}`}
          type={type.checkbox}
          style={{ margin: '0 45%' }}
          component={FieldInput}
        />
      ),
    },
    {
      Header: () => {
        return (
          <span>
            Sub Department <span style={{ color: '#F44336' }}>*</span>
          </span>
        )
      },
      accessor: 'subDepartmentName',
      width: 400,
    },
  ],
  tProjectUser: [
    {
      Header: 'Project',
      accessor: 'projectName',
      width: 250,
    },
    {
      Header: 'Modified By',
      accessor: 'modifiedBy',
      width: 150,
    },
    {
      Header: 'Modified Date',
      accessor: 'modifiedDate',
      width: 150,
      Cell: row => <Moment format="DD MMM YYYY">{row.value}</Moment>,
    },
    {},
  ],
  tProjectUserList: [
    {
      Header: '',
      width: 30,
      Cell: row => <Icon name="trash alternate" link color="red" />,
    },
    {
      Header: 'Username',
      accessor: 'userName',
      width: 250,
      style: {
        textAlign: 'center',
      },
    },
  ],
}
